import { toast } from "sonner";

/** Two opt-in "send an email" tickboxes (staff + participant). `labels` = [staff, participant]. */
export function NotifyCheckboxes({ value, onChange, labels, testid, hint }) {
  const row = (k, label) => (
    <label key={k} className="flex items-center gap-2 cursor-pointer" data-testid={`${testid}-${k}-row`}>
      <input type="checkbox" checked={!!value[k]} onChange={(e) => onChange({ ...value, [k]: e.target.checked })}
        className="h-4 w-4 accent-teal-600" data-testid={`${testid}-${k}`} />
      <span className="text-xs text-slate-700">{label}</span>
    </label>
  );
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 space-y-1.5" data-testid={testid}>
      {row("staff", labels[0])}
      {row("participant", labels[1])}
      <p className="text-[11px] text-slate-400">{hint || "Sent when you save, using the email templates in Settings."}</p>
    </div>
  );
}

/** Tell the office what the optional emails actually did (incl. who had no email address). */
export function toastNotifications(n) {
  if (!n) return;
  if (n.held) toast.message("Emails will go once a Rostering Manager overrides this shift's hard block.");
  if (n.sent) toast.success(`${n.sent} email${n.sent === 1 ? "" : "s"} sent`);
  if (n.skipped?.length) toast.warning(`Not emailed: ${n.skipped.join(", ")}`);
}
